
export class WorkstationEfficiencyModel {
    workstationId: string;
    workstationDesc: string;
    efficiency: number; // for the current operation in the hour

    totalPlanSecs: number; // planned garments * operation smv
    receivedGmtPlanSecs: number; // current processed garments * operation smv
    totalSpentSecs: number; // completed garments * operation smv
    idleTime: number;

    hour: number;

    constructor(workstationId: string,
        workstationDesc: string,
        efficiency: number,
        totalPlanSecs: number,
        receivedGmtPlanSecs: number,
        totalSpentSecs: number,
        idleTime: number,
        hour: number
    ) {
            this.workstationId = workstationId;
            this.workstationDesc = workstationDesc;
            this.efficiency = efficiency;

            this.totalPlanSecs = totalPlanSecs;
            this.receivedGmtPlanSecs = receivedGmtPlanSecs;
            this.totalSpentSecs = totalSpentSecs;
            this.idleTime = idleTime;

            this.hour= hour;
    }
}